import React from 'react';
import { Button, LocaleProvider, notification } from 'antd';
import enEn from 'antd/lib/locale-provider/en_US';
import viVn from 'antd/lib/locale-provider/vi_VN';
import { DashboardPropsType } from 'o2o_layout';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { History, Location } from 'history';
import { UISetting, User } from 'o2o_layout/lib/common/model';
import queryString from 'query-string';

import PubSub from 'pubsub-js';
import { IState } from '../../../redux/reducer';
import { updateLocale } from 'moment';
import {
  showSiderMainLayout,
  updateBreakpoint,
  commonActionFromDAL,
  commonActionFromDALV2,
  showCommonError,
  typeUpdateLocate,
  typeUpdateBreakpoint,
  setGlobalLoading,
} from '../../../common/actions/CommonAction';
import { getPrimaryColor } from '../../../common/helper';
import { UI, Authen } from '../../../redux/model';
import { useSelector } from '../../../redux/store';
import DrawerCommonError from '../../../shares/CommonError';

import { BIGDATA_CONSTANT } from '../../../common/constant';
// import { DrawerSupport } from '../../../shares/send-ticket-caresoft/DrawerSupport';
import ModernLayout from './ModernLayout';
import { DrawerQuickAccessComponent } from 'o2o_common_ui';
import { extendToken } from '../../../modules/users/ConsoleUsersAction';
import { userLogout, userLogoutAll } from '../../../modules/login/actions/LoginAction';

function mapStateToProps(rootState: IState) {
  return {
    ui: rootState.ui,
    locale: rootState.locale,
    user: rootState.user,
    uiSetting: rootState.uiSetting,
    authen: rootState.authen,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    showSiderMainLayout: bindActionCreators(showSiderMainLayout, dispatch),
    updateLocale: bindActionCreators(updateLocale, dispatch),
    updateBreakpoint: bindActionCreators(updateBreakpoint, dispatch),
    extendToken: bindActionCreators(extendToken, dispatch),
    commonActionFromDAL: bindActionCreators(commonActionFromDAL, dispatch),
    commonActionFromDALV2: bindActionCreators(commonActionFromDALV2, dispatch),
    showCommonError: bindActionCreators(showCommonError, dispatch),
    userLogout: bindActionCreators(userLogout, dispatch),
    userLogoutAll: bindActionCreators(userLogoutAll, dispatch),
    setGlobalLoading: bindActionCreators(setGlobalLoading, dispatch),
  };
}

export interface DashboardProps extends DashboardPropsType {
  ui?: UI;
  updateLocale: typeUpdateLocate;
  locale: any;
  user?: User;
  selectedLeftNav: any;
  selectedSubMenu?: any;
  location: Location;
  history: History;
  updateBreakpoint: typeUpdateBreakpoint;
  showCommonError: any;
  landing?: boolean;
  uiSetting: UISetting;
  extendToken: any;
  commonActionFromDAL: any;
  commonActionFromDALV2: any;
  authen: Authen;

  renderBreadCrumbTop?: any;
  renderTitle?: any;
  updatePinnedConnections: any;
  updatePinnedDataModels: any;
}

export class DashboardPageComponent extends React.Component<DashboardProps, any> {
  debounceTimeout: any;

  constructor(props: DashboardProps) {
    super(props);
    this.state = {
      visiblePopoverPinWorkflows: false as boolean,
      visiblePopoverPinSegments: false as boolean,
      visiblePopoverPinConnections: false as boolean,
      isVisible: false,
      breakpoint: this.getScreenSize(),
      heightMenuLeft: window.innerHeight,
      companyName: 'pangoCDP',
      isVisibleBookMark: false,
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleResize();
  }

  toggleDrawerBookmark = () => {
    this.setState((prevState: any) => {
      return {
        isVisibleBookMark: !prevState.isVisibleBookMark,
      };
    });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps: Readonly<DashboardProps>, prevState: Readonly<any>, snapshot?: any): void {
    if (this.props.authen.changePassword !== prevProps.authen.changePassword) {
      if (this.props.authen.changePassword === true) {
        this.props.history.push({
          pathname: '/security/change-password',
        });
      }
    } else if (this.props.authen.restrictEnabled2FA !== prevProps.authen.restrictEnabled2FA) {
      if (this.props.authen.restrictEnabled2FA === true) {
        this.props.history.push({
          pathname: '/security/2fa-security',
        });
      }
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    PubSub.subscribe('EXTEND_TOKEN', this.extendToken);
    PubSub.subscribe('TOO_MANY_REQUEST', this.tooManyReques);
    if (this.props.authen.changePassword) {
      this.props.history.push({
        pathname: '/security/change-password',
      });
    } else if (this.props.authen.restrictEnabled2FA) {
      this.props.history.push({
        pathname: '/security/2fa-security',
      });
    }
  }

  tooManyReques = () => {
    notification.warn({
      message: 'TOO_MANY_REQUEST',
      description: 'There are too many requests in a short period.',
    });
  };

  openExtendPopup = () => {
    const btn = (
      <Button
        type='primary'
        disabled={this.state.isLoadingExtend}
        size='small'
        onClick={() => {
          this.setState(
            {
              isLoadingExtend: true,
            },
            () => {
              notification.open({
                key: 'extend_noti',
                message: 'Your token has been expending. wait a second',
                description: 'loading...',
              });
              this.props.extendToken().then(() => {
                notification.open({
                  key: 'extend_noti',
                  message: 'Your token has been extended',
                  description: '',
                });
                setTimeout(() => {
                  notification.close('extend_noti');
                }, 1000);

                this.setState({
                  isLoadingExtend: false,
                });
              });
            }
          );
        }}
      >
        Extend
      </Button>
    );

    const args = {
      message: 'Your session is expiring soon',
      description: 'Click the button to extend your session',
      duration: 0,
      key: 'extend_noti',
      btn,
      onClose: () => {
        this.setState({
          isExtending: false,
        });
      },
    };

    notification.open(args);
  };

  extendToken = (a: any, b: any) => {
    if (b) {
      if (!this.state.isExtending) {
        this.setState(
          {
            isLoadingExtend: true,
            isExtending: true,
          },
          () => {
            this.props
              .extendToken()
              .then(() => {
                this.setState({
                  isLoadingExtend: false,
                  isExtending: false,
                });
              })
              .catch(() => {
                this.setState({
                  isLoadingExtend: false,
                  isExtending: false,
                });
              });
          }
        );
      }
    }
  };

  getScreenSize = () => {
    const { innerWidth } = window;
    let breakpoint = 'xs';
    if (innerWidth >= 1920) {
      breakpoint = 'xl';
    } else if (innerWidth >= 1280) {
      breakpoint = 'lg';
    } else if (innerWidth >= 768) {
      breakpoint = 'md';
    } else if (innerWidth >= 400) {
      breakpoint = 'sm';
    }

    return breakpoint;
  };

  handleResize = () => {
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      const breakpoint = this.getScreenSize();
      this.setState({
        breakpoint: breakpoint,
        heightMenuLeft: window.innerHeight,
      });
      this.props.updateBreakpoint(breakpoint, window.innerHeight);

      if (
        this.props.ui &&
        this.props.ui.showSider == true &&
        (breakpoint == 'xs' || breakpoint == 'sm' || breakpoint == 'md')
      ) {
        this.props.showSiderMainLayout(false);
      }
    }, 250);
  };

  getQuery = () => {
    const q = queryString.parse(this.props.location.search);
    return q;
  };

  getCommonError = () => {
    const commonError = useSelector((state: IState) => state.ui.commonError);
    return commonError;
  };

  render() {
    return (
      <LocaleProvider locale={this.props.locale ? (this.props.locale.locale == 'en' ? enEn : viVn) : viVn}>
        <React.Fragment>
          <ModernLayout {...this.props} toggleDrawerBookmark={this.toggleDrawerBookmark} />

          <DrawerCommonError
            visible={this.getCommonError() ? true : false}
            onClose={() => {
              this.props.showCommonError(undefined);
            }}
          />

          {/* <DrawerSupport
            commonActionFromDALV2={this.props.commonActionFromDALV2}
            visible={this.state.visibleSupport}
            onClose={() => {
              this.setState({
                visibleSupport: false,
              });
            }}
          /> */}

          <DrawerQuickAccessComponent
            title='QUICK ACCESS'
            visible={this.state.isVisibleBookMark}
            onClose={this.toggleDrawerBookmark}
            commonActionFromDALV2={this.props.commonActionFromDALV2}
            application='CDP'
            api_prefix={BIGDATA_CONSTANT.url.account || ''}
            baseUrlCDP={process.env.REACT_APP_CDP_APP || ''}
            baseUrlCON={process.env.REACT_APP_CON_APP || ''}
            baseUrlDMA={process.env.REACT_APP_DMA_APP || ''}
            color={getPrimaryColor(this.props.uiSetting)}
          />
        </React.Fragment>
      </LocaleProvider>
    );
  }
}

const ModernLayoutContainer = connect<any, any>(mapStateToProps, mapDispatchToProps)(DashboardPageComponent);

export default ModernLayoutContainer;
